import { ERROR_CODES } from "./codes"
import type { ErrorCode } from "./codes"

/**
 * Extracts an error code from an error if it matches the DOMAIN-XNNN pattern
 * and exists in the ERROR_CODES registry.
 *
 * Client-safe — no Node dependencies. Can be imported from "use client" components.
 * Useful in error.tsx where the original AppError may not be available.
 */
const ERROR_CODE_PATTERN = /^[A-Z]+-[A-Z]\d{3}$/

export const extractErrorCode = (
  error: Error & { code?: string }
): ErrorCode | null => {
  if (!error.code || !ERROR_CODE_PATTERN.test(error.code)) {
    return null
  }
  return error.code in ERROR_CODES ? (error.code as ErrorCode) : null
}
